import { db } from '../firebase';
import { collection, addDoc, getDocs, doc, updateDoc, deleteDoc, query, where, getDoc } from 'firebase/firestore';

const shopsCollection = collection(db, 'shops');

// Create a new shop profile
export async function createShopProfile(shopData) {
  try {
    const docRef = await addDoc(shopsCollection, {
      ...shopData,
      createdAt: new Date().toISOString(),
      status: 'inactive',
      isVerified: false,
      totalProducts: 0,
      totalSales: 0,
      rating: 0,
      reviewCount: 0
    });
    return { id: docRef.id, ...shopData };
  } catch (error) {
    console.error('Error creating shop profile:', error);
    throw error;
  }
}

// Get shop profile by user ID
export async function getShopProfile(userId) {
  try {
    const q = query(shopsCollection, where("sellerId", "==", userId));
    const snapshot = await getDocs(q);
    
    if (snapshot.empty) {
      return null;
    }
    
    const doc = snapshot.docs[0];
    return { id: doc.id, ...doc.data() };
  } catch (error) {
    console.error('Error getting shop profile:', error);
    throw error;
  }
}

// Get all shops (for admin purposes)
export async function getAllShops() {
  try {
    const snapshot = await getDocs(shopsCollection);
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error('Error getting all shops:', error);
    throw error;
  }
}

// Update shop profile
export async function updateShopProfile(shopId, data) {
  try {
    const shopRef = doc(db, 'shops', shopId);
    await updateDoc(shopRef, {
      ...data,
      updatedAt: new Date().toISOString()
    });
  } catch (error) {
    console.error('Error updating shop profile:', error);
    throw error;
  }
}

// Delete shop profile
export async function deleteShopProfile(shopId) {
  try {
    const shopRef = doc(db, 'shops', shopId);
    await deleteDoc(shopRef);
  } catch (error) {
    console.error('Error deleting shop profile:', error);
    throw error;
  }
}

// Verify shop (admin function)
export async function verifyShop(shopId) {
  try {
    const shopRef = doc(db, 'shops', shopId);
    await updateDoc(shopRef, {
      isVerified: true,
      verifiedAt: new Date().toISOString()
    });
  } catch (error) {
    console.error('Error verifying shop:', error);
    throw error;
  }
}

// Update shop stats (called when products/sales change)
export async function updateShopStats(shopId, stats) {
  try {
    const shopRef = doc(db, 'shops', shopId);
    await updateDoc(shopRef, {
      ...stats,
      updatedAt: new Date().toISOString()
    });
  } catch (error) {
    console.error('Error updating shop stats:', error);
    throw error;
  }
} 